import { render, staticRenderFns } from "./despatch.vue?vue&type=template&id=48baaa54&scoped=true&"
import script from "./despatch.vue?vue&type=script&lang=js&"
export * from "./despatch.vue?vue&type=script&lang=js&"
import style0 from "./despatch.vue?vue&type=style&index=0&id=48baaa54&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48baaa54",
  null
  
)

export default component.exports